// extracted by mini-css-extract-plugin
export default {"right":"styles-module__right__src-labstep-web-components-EntityUserRoleRequirement-Table-_PA2rY"};